export const randomString = (length: number, dateStamp = false) => {
  if (dateStamp) length -= 14;
  var result = [];
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result.push(
      characters.charAt(Math.floor(Math.random() * charactersLength))
    );
  }
  return dateStamp ? `${result.join("")}-${Date.now()}` : result.join("");
};

export const encodeString = (data: string) => {
  const enc = new TextEncoder();
  return enc.encode(data);
};

export const generateKeys = () => {
  return crypto.subtle.generateKey(
    {
      name: "RSASSA-PKCS1-v1_5",
      modulusLength: 2048,
      publicExponent: new Uint8Array([1, 0, 1]),
      hash: "SHA-512",
    },
    true,
    ["sign", "verify"]
  );
};

export const stringifyPublicKey = (buffer: any) => {
  const asString = String.fromCharCode.apply(
    null,
    new Uint8Array(buffer) as any
  );
  const asBase64 = btoa(asString);
  const pemExported = `-----BEGIN RSA PUBLIC KEY-----\r\n${asBase64}\r\n-----END RSA PUBLIC KEY-----`;
  return pemExported;
};
export const stringifyPrivateKey = (buffer: any) => {
  const asString = String.fromCharCode.apply(
    null,
    new Uint8Array(buffer) as any
  );
  const asBase64 = btoa(asString);
  const pemExported = `-----BEGIN RSA PRIVATE KEY-----\r\n${asBase64}\r\n-----END RSA PRIVATE KEY-----`;
  return pemExported;
};

export const stringifyBuffer = (buffer: any) => {
  const asString = String.fromCharCode.apply(
    null,
    new Uint8Array(buffer) as any
  );
  const asBase64 = btoa(asString);
  return asBase64;
};

export const encodeText = (str: string) => {
  return unescape(encodeURIComponent(str));
};

export const decodeText = (str: string) => {
  return decodeURIComponent(escape(str));
};

function removeLines(str: string) {
  return str.replace("\n", "").replace("\r", "");
}

function base64ToArrayBuffer(b64: string) {
  var byteString = window.atob(b64);
  var byteArray = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    byteArray[i] = byteString.charCodeAt(i);
  }

  return byteArray;
}

function pemToArrayBuffer(pem: string) {
  var b64Lines = removeLines(pem);
  var b64Prefix = b64Lines.replace("-----BEGIN RSA PUBLIC KEY-----", "");
  var b64Final = b64Prefix.replace("-----END RSA PUBLIC KEY-----", "");

  return base64ToArrayBuffer(b64Final);
}

export const decodePem = async (publicKey: string) => {
  return await crypto.subtle.importKey(
    "spki",
    pemToArrayBuffer(publicKey),
    {
      name: "RSASSA-PKCS1-v1_5",
      hash: { name: "SHA-512" },
    },
    true,
    ["verify"]
  );
};

export const importPublicKeyPem = (pem: string) => {
  // fetch the part of the PEM string between header and footer
  const pemHeader = "-----BEGIN RSA PUBLIC KEY-----";
  const pemFooter = "-----END RSA PUBLIC KEY-----";
  const pemContents = pem.substring(
    pemHeader.length,
    pem.length - pemFooter.length
  );
  // base64 decode the string to get the binary data
  const binaryDerString = window.atob(pemContents);
  // convert from a binary string to an ArrayBuffer
  const binaryDer = str2ab(binaryDerString);

  return window.crypto.subtle.importKey(
    "spki",
    binaryDer,
    {
      name: "RSASSA-PKCS1-v1_5",
      hash: { name: "SHA-512" },
    },
    true,
    ["verify"]
  );
};
export const importPrivateKeyPem = (pem: string) => {
  // fetch the part of the PEM string between header and footer
  const pemHeader = "-----BEGIN RSA PRIVATE KEY-----";
  const pemFooter = "-----END RSA PRIVATE KEY-----";
  const pemContents = pem.substring(
    pemHeader.length,
    pem.length - pemFooter.length
  );
  // base64 decode the string to get the binary data
  const binaryDerString = window.atob(pemContents);
  // convert from a binary string to an ArrayBuffer
  const binaryDer = str2ab(binaryDerString);

  return window.crypto.subtle.importKey(
    "pkcs8",
    binaryDer,
    {
      name: "RSASSA-PKCS1-v1_5",
      hash: { name: "SHA-512" },
    },
    true,
    ["sign"]
  );
};

export const str2ab = (str: string) => {
  const buf = new ArrayBuffer(str.length);
  const bufView = new Uint8Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}
